module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "spw-dark.ac00c5db.svg";